import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {

  constructor(
    private translateService: TranslateService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // get currently selected language
    const language = this.translateService.currentLang || 'de';

    const authRequest = request.clone({
      headers: request.headers.set('X-Previmo-Language', language)
    });

    return next.handle(authRequest);
  }
}
